import { useCallback, useState } from "react";
import { Route, Routes } from "react-router-dom";
import AppShell from "./components/AppShell";
import { api } from "./lib/api";
import { useApi } from "./hooks/useApi";
import Home from "./pages/Home";
import Reunions from "./pages/Reunions";
import ReunionDetail from "./pages/ReunionDetail";
import Members from "./pages/Members";
import Activate from "./pages/Activate";
import College from "./pages/College";
import CollegeDays from "./pages/CollegeDays";
import Memorials from "./pages/Memorials";
import NotFound from "./pages/NotFound";
import Stories from "./pages/Stories";
import StoryDetail from "./pages/StoryDetail";

export default function App() {
  const sessionLoader = useCallback(() => api("/api/session"), []);
  const { data: session, reload: reloadSession } = useApi(sessionLoader, []);
  const [reunionVersion, setReunionVersion] = useState(0);
  const authenticated = Boolean(session?.authenticated);
  const canContribute = Number(session?.user?.memberId) > 0;

  return (
    <AppShell authenticated={authenticated} user={session?.user}>
      <Routes>
        <Route path="/" element={<Home authenticated={authenticated} canContribute={canContribute} />} />
        <Route
          path="/reunions"
          element={<Reunions authenticated={authenticated} canContribute={canContribute} version={reunionVersion} onCreated={() => setReunionVersion((value) => value + 1)} />}
        />
        <Route
          path="/reunions/:reunionId"
          element={<ReunionDetail authenticated={authenticated} canContribute={canContribute} isAdministrator={session?.user?.role === "administrator"} onLogin={reloadSession} version={reunionVersion} onUpdated={() => setReunionVersion((value) => value + 1)} />}
        />
        <Route path="/college-days" element={<CollegeDays session={session} onLogin={reloadSession} isAdministrator={session?.user?.role === "administrator"} />} />
        <Route path="/members" element={<Members session={session} onLogin={reloadSession} onLogout={reloadSession} />} />
        <Route path="/stories" element={<Stories session={session} onLogin={reloadSession} />} />
        <Route path="/stories/:storyId" element={<StoryDetail session={session} onLogin={reloadSession} />} />
        <Route path="/in-memoriam" element={<Memorials session={session} onLogin={reloadSession} />} />
        <Route path="/activate" element={<Activate onActivated={reloadSession} />} />
        <Route path="/college" element={<College />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
}
